<template>
  <layout-main-inner title="出库记录">
    <layout-card-wrap v-loading="loading">
      <el-form @submit.native.prevent
               label-width="90px"
               label-position="left">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="出库类型：">
              <el-select @change="fetchList"
                         style="width: 100%"
                         v-model="config.ownerRange"
                         placeholder="请选择出库类型">
                <el-option v-for="item in ownerRange"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="出库日期：">
              <el-date-picker v-model="config.time"
                              :editable="false"
                              unlink-panels
                              style="width: 100%;"
                              type="daterange"
                              range-separator="-"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="出库单号：">
              <el-input placeholder="请输入出库单号"
                        v-model="config.outstockCode">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="标签序号：">
              <el-input placeholder="请输入标签序号"
                        v-model.number="config.tagNo">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="选择商品：">
              <ent-product-auto-select :multiple="true"
                                       style="width: 100%"
                                       v-model="config.productIds" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收货客户：">
              <ent-delivery-auto-select style="width: 100%"
                                        v-model="config.deliveryAddressId" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-button type="primary"
                         @click="handleCurrentChange(1)">查询</el-button>
              <el-button type="primary"
                         @click="downloadList">下载</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- <template slot="form">
        <el-radio-group style="margin-right: 10px;"
                        v-model="config.ownerRange"
                        @change="handleCurrentChange(1)">
          <el-radio-button :label="null">全部</el-radio-button>
          <el-radio-button :label="1">企业出库</el-radio-button>
          <el-radio-button :label="0">客户出库</el-radio-button>
        </el-radio-group>
        <el-date-picker v-model="config.time"
                        @change="handleCurrentChange(1)"
                        type="daterange"
                        unlink-panels
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
        </el-date-picker>
        <el-input placeholder="请输入出库单号"
                  v-model="config.outstockCode"
                  clearable=""
                  style="width: 200px;margin-left:10px">
          <el-button slot="append"
                     icon="el-icon-search"
                     @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template> -->
      <el-table border
                v-loading="loading"
                :data="list">
        <el-table-column label="出库单号"
                         fixed="left"
                         width="160">
          <template slot-scope="{row}">
            <!-- <link-route :link-to="`/goodsreturn-detail?vendorId=${row.vendorId}&goodsReturnId=${row.goodsReturnId}`">
              {{row.outstockCode}}
            </link-route> -->
            {{row.outstockCode}}
          </template>
        </el-table-column>
        <el-table-column label="商品名称"
                         min-width="300"
                         prop="productNames"></el-table-column>
        <el-table-column label="出库数"
                         min-width="60"
                         prop="outGoodsCount">
        </el-table-column>
        <el-table-column label="订单号"
                         min-width="150"
                         prop="orderNumber"></el-table-column>
        <el-table-column label="物流单号"
                         width="140"
                         prop="courierNumber"></el-table-column>
        <el-table-column label="出库类型"
                         width="80"
                         prop="outboundType"></el-table-column>
        <el-table-column label="收货信息"
                         prop="outGoodsCount"
                         min-width="280">
          <template slot-scope="{row}">
            <div>单据归属：{{row.ownerName}}</div>
            <!-- <div>收货客户：</div> -->
            <div>收货客户：{{row.dealerName}}
              <template>-{{row.deliveryName}}</template>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="出库时间"
                         width="140"
                         prop="outGoodsCount">
          <template slot-scope="{row}">
            {{ row.outstockTime | dateformat()}}
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         fixed="right"
                         width="60">
          <template slot-scope="{row}">
            <el-button type="text"
                       @click="viewDetail(row)">明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination background
                       @current-change="handleCurrentChange"
                       :current-page.sync="config.pageNum"
                       :page-size="config.pageSize"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
      </template>
    </layout-card-wrap>
    <product-count-modal ref="modal" />
  </layout-main-inner>
</template>

<script>
import EntProductAutoSelect from '@/components/business/ent-product-auto-select.vue'
import { mapState } from 'vuex'
import ProductCountModal from '../outstock/busi/product-count-modal.vue'
import EntDeliveryAutoSelect from '@/components/business/ent-delivery-auto-select.vue'
import Outstock from '@/service/outstock'
import { downloadBlobFile } from '@/utils/index'
export default {
  name: 'goods-outstock',
  components: { ProductCountModal, EntProductAutoSelect, EntDeliveryAutoSelect },
  data () {
    return {
      loading: false,
      config: { ownerRange: null, pageNum: 1, pageSize: 10, outstockCode: '', time: '', tagNo: '', productIds: [], deliveryAddressId: null },
      list: [],
      total: 0,
      ownerRange: [
        { label: '全部出库', value: null },
        { label: '客户出库', value: 0 },
        { label: '企业出库', value: 1 }
      ]
    }
  },
  computed: {
    ...mapState({
      query: state => state.common.query
    })
  },
  methods: {
    downloadList () {
      this.loading = true
      Outstock.downloadoutstocks({ ...this.getQuery() })
        .then(res => {
          this.loading = false
          downloadBlobFile(res)
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    getQuery () {
      let time = this.config.time || []
      return {
        ...this.config,
        ownerRange: this.config.ownerRange,
        pageNum: this.config.pageNum,
        pageSize: this.config.pageSize,
        outstockCode: this.config.outstockCode,
        beginTime: time[0] ? +time[0] : null,
        endTime: time[1] ? +time[1] : null,
        time: undefined
      }
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('outstock/getoutstocks', {
        payload: { ...this.getQuery() },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    viewDetail (row) {
      console.log(row)
      this.$refs.modal.searchOutstock(row, '出库商品明细')
    }
  },
  created () {
    if (this.query) {
      this.config = { ...this.config, ...this.query }
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
<style lang="stylus"></style>
